import { formatGrowth, formatVolume } from 'utils/helpers';
import { DATA_SOURCES } from '@/config/constants';
import { createSourceBreadCrumbs } from './createSourceBreadCrumbs';
import { useGoogleData, useUserIndustries } from 'utils/hooks';

const useGoogleSubcategories = ({ parent, country }) =>
    useGoogleData({
        enabled: !!(parent && country),
        data: {
            categories: parent ? parent.children : null,
            countries: country ? [country.id] : null,
        },
        paginateBy: 'categories',
    });

const searchMetrics = [
    { key: 'volume', label: 'searches', formatter: formatVolume },
    { key: 'YoY', label: 'YoY', formatter: formatGrowth },
];

const { BreadCrumbs: GoogleBreadCrumbs } = createSourceBreadCrumbs({
    dataSource: DATA_SOURCES.GOOGLE,
    useSubcategories: useGoogleSubcategories,
    useIndustries: useUserIndustries,
    metrics: searchMetrics,
});

export default GoogleBreadCrumbs;
